/**
 * useActiveOrg — resuelve la org activa (== tax_client_id del partner)
 * desde tax-account GET /auth/me. Mismo patrón que el facturador
 * (use-auth-context): las páginas que llaman endpoints admin con
 * :client_id en el path deben gatear sus queries con
 * `enabled: !!activeOrgId`.
 */

import { useQuery } from '@tanstack/react-query'
import { authApi, hasValidAccessToken } from '@/lib/api'

export function useActiveOrg() {
  const query = useQuery({
    queryKey: ['auth-me'],
    queryFn: authApi.me,
    enabled: hasValidAccessToken(),
    staleTime: 60 * 1000,
    retry: 1,
  })
  return {
    ...query,
    activeOrgId: query.data?.active_org?.id ?? null,
    activeOrgName: query.data?.active_org?.razon_social ?? null,
  }
}
